import React from 'react';
import PropTypes from 'prop-types';
import { Table } from 'reactstrap';
const EmployeeJobsTable = ({
  jobs: _jobs = []
}) => {
  const rows = _jobs.map(job => /*#__PURE__*/React.createElement("tr", {
    key: job.id
  }, /*#__PURE__*/React.createElement("td", null, job.jobNumber), /*#__PURE__*/React.createElement("td", null, job.type)));
  return /*#__PURE__*/React.createElement(Table, {
    striped: true,
    bordered: true,
    size: "sm"
  }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, "Job"), /*#__PURE__*/React.createElement("th", null, "Type"))), /*#__PURE__*/React.createElement("tbody", null, rows));
};
EmployeeJobsTable.propTypes = {
  // data: PropTypes.object
  jobs: PropTypes.arrayOf(PropTypes.shape({}))
};
export default EmployeeJobsTable;